import { Divider, Tag } from 'antd'
import Flex from 'components/Flex'
import styled from 'styled-components'
import { COLORS } from 'theme'
import { FONT } from 'theme/font'
import { StarFilled } from '@ant-design/icons'
import { StarOutlined } from '@ant-design/icons'
export const Chart = styled.div`
  margin-top: 10px;

  background: ${COLORS.PRIMARY_GREY_T_98};
  border: 1px solid ${COLORS.GREY_T_80};
  border-radius: 10px;
  overflow: auto;
`
export const SkillsWrapper = styled.div`
  /* margin-top: 24px; */
  display: flex;
  flex-direction: column;
  gap: 0.5rem;
`
export const Note = styled.div`
  font-size: 14px;
  font-weight: 500;
  color: #4d568e;
  margin-bottom: 8px;
`
export const StyledTag = styled(Tag)`
  border: 1px solid #e3deff !important;
  background-color: #fbfaff !important;
  color: #3249d7 !important;
  font-weight: 500;
  border-radius: 12px !important;
  padding: 6px 12px !important;
  font-size: 16px !important;
  display: flex !important;
  align-items: center;
  .anticon-close {
    color: #3249d7;
    margin-left: 8px;
    &:hover {
      color: #3249d7;
    }
  }
`

export const StyledStarFilled = styled(StarFilled)`
  margin-left: 8px;
  color: #5b4eff;
`

export const StyledStarOutlined = styled(StarOutlined)`
  margin-left: 8px;
  color: #5b4eff;
`
export const SkillList = styled.div`
  display: flex;
  flex-wrap: wrap;
  gap: 1rem;
`

export const ChartElement = styled(Flex)`
  border-right: ${props =>
    props?.borderLast ? `1px solid ${COLORS.GREY_T_80}` : 'none'};
  padding-right: 5px;
  gap: 5px;
`
export const SubChart = styled(Flex)`
  padding: 17px;
  gap: 10px;
`
export const Level = styled(Flex)`
  font-size: ${FONT.F_LG};
  color: ${COLORS.GREY_T_60};
  sub {
    font-size: 10px;
    padding-top: 5px;
  }
`
export const Marks = styled.div`
  font-size: ${FONT.F_LG};
  color: ${COLORS.GREY_T_30};
`

export const SkillsText = styled.div`
  margin-top: 8px;
  font-family: 'Plus Jakarta Sans';
  font-size: 14px;
  font-weight: 500;
  font-style: 'normal';
  line-height: 18px;
  color: #999fac;
  margin-bottom: 10px;
`

export const MediumLabel = styled.div`
  font-family: 'Plus Jakarta Sans';
  font-style: normal;
  font-weight: 700;
  font-size: 16px;
  line-height: 20px;
  color: #4d566e;
`

export const ParaText = styled.div`
  padding-left: 45px;
  padding-top: 10px;
`
export const QualificationDiv = styled.div`
  padding: 10px;
  width: 100%;
  left: 0;
  top: 0;
  position: sticky;
  z-index: 1;
  background-color: white;
`

export const MulitiSlectbox = styled.div`
  display: flex;
  gap: 2rem;
  ${''}
  margin-bottom: 25px;
`
export const MulitiSelectsboxes = styled.div`
  display: flex;
  gap: 1rem;
  margin-top: 1rem;
`

export const DeleteButton = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  width: 65px;
  background: #fafafb;
  border: ${props => (props.border ? props.border : '1px solid #e6e7ea')};
  border-radius: 10px;
  cursor: pointer;
  height: ${props => (props.height ? props.height : '42px')};
`
export const LabelContent = styled.span`
  font-family: 'Plus Jakarta Sans';
  font-style: normal;
  font-weight: 500;
  font-size: 14px;
  line-height: 18px;
  color: #999fac;
  margin-top: 10px;
`

export const SkillSetLabel = styled.label`
  display: flex;
  align-items: left;
  flex-direction: column;
  font-family: 'Plus Jakarta Sans';
  font-style: normal;
  font-weight: 500;
  font-size: 14px;
  line-height: 18px;
  color: #4d566e;
`

export const NoDataFound = styled.div`
  display: flex;
  flex-direction: column;
  -webkit-box-pack: center;
  justify-content: center;
  -webkit-box-align: center;
  align-items: center;
  font-size: small;
  font-weight: 600;
  border: 1px solid rgb(220, 236, 250);
  margin: 0em 0.5em;
  border-radius: 5px;
  padding: 11.5em 0em;
`

export const StyledDivider = styled(Divider)`
  font-size: smaller !important;
  font-weight: 700 !important;
  border-top-color: black !important;
  transform: none !important;

  &.ant-divider-horizontal.ant-divider-with-text::before,
  &.ant-divider-horizontal.ant-divider-with-text::after {
    position: relative;
    width: 50%;
    border-top: 1px solid transparent;
    border-top-color: inherit;
    border-bottom: 0;
    transform: none !important;
    content: '';
  }
`
export const DividerGap = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  font-size: 0.8em;
  font-weight: 550;
  width: 100%;
  padding-left: 1em;
  gap: 0.3em;
`
export const StyledDashedBorderBox = styled.div`
  border: 2px dashed #d6dbf7;
  padding: 20px;
  border-radius: 10px;
  background-color: #f9fafe;
  margin-top: 30px;
  position: relative;
`
export const ButtonRowDiv = styled.div`
  display: flex;
  flex-direction: row;
  gap: 10px;
  align-items: center;
  justify-content: center;
  position: absolute;
  top: -38px;
`

export const AndOrStyle = styled.div`
  width: -webkit-fill-available;
`
export const ArrearSubText = styled.div`
  font-family: Plus Jakarta Sans;
  font-size: 12px;
  font-weight: 400;
  line-height: 18px;
  color: #969696;
`

export const MarginDiv = styled.div`
  margin-top: 10px;
`
